import type { TRuleWithTheme } from '@ackee/fela';

export const modalContainer: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 6rem)',
    width: '100%',
});

export const modalTextContainer: TRuleWithTheme = () => ({
    tabletLarge: {
        maxWidth: '55%',
    },
});

export const iframeContainer: TRuleWithTheme = () => ({
    flexGrow: 1,
    marginTop: '2rem',
});

export const iframe: TRuleWithTheme = () => ({
    border: 'none',
    width: '100%',
    height: '100%',
});
